import React from 'react';

import PropTypes from 'prop-types';

import { spacing } from '@sine/sine-ui-components';

const BRAND = {
  'Visa': 'visa',
  'MasterCard': 'master',
  'American Express': 'american-express',
  'Unknown': 'unknown-card',
};

export function CardLogo({ brand }) {
  const src = `/img/svg/${BRAND[brand] || BRAND.Unknown}.svg`;
  return <img width={spacing(4)} src={src} />;
}

CardLogo.propTypes = {
  brand: PropTypes.string.isRequired,
};
